import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined'
import type { ChartAlertApplySummary } from '../../screener/aiChat/types'

type Props = {
    alert: ChartAlertApplySummary
}

function formatTrigger(raw: string | undefined): string | undefined {
    if (!raw) return undefined
    return raw
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase())
}

export default function AlertAppliedCard({ alert }: Props) {
    const meta = [
        alert.symbol,
        alert.operator ? alert.operator.replace(/_/g, ' ') : undefined,
        formatTrigger(alert.trigger),
        alert.expiryLabel,
    ].filter(Boolean)

    return (
        <Box
            sx={{
                mt: 1.25,
                px: 1.25,
                py: 1,
                borderRadius: 1.5,
                bgcolor: 'action.hover',
                border: 1,
                borderColor: 'divider',
            }}
        >
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <NotificationsActiveOutlinedIcon
                    sx={{ fontSize: 16, mt: '2px', flexShrink: 0, color: 'success.main' }}
                />
                <Stack spacing={0.375} sx={{ minWidth: 0 }}>
                    <Typography variant="caption" sx={{ fontWeight: 600, lineHeight: 1.45, color: 'text.primary' }}>
                        Alert applied
                    </Typography>
                    <Typography variant="caption" sx={{ lineHeight: 1.5, color: 'text.secondary', wordBreak: 'break-word' }}>
                        {alert.message}
                    </Typography>
                    {meta.length > 0 && (
                        <Typography variant="caption" sx={{ lineHeight: 1.4, color: 'text.tertiary' }}>
                            {meta.join(' · ')}
                        </Typography>
                    )}
                </Stack>
            </Stack>
        </Box>
    )
}
